import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ILicense, ILicenseBulkDiscount, LicenseBtnNameType } from '../../../Interface/license'

@Component({
  selector: 'bmcore-license-list',
  templateUrl: './bmcore-license-list.component.html',
  styleUrls: ['./bmcore-license-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLicenseListComponent {
  @Input() licenses: ILicense[] = []
  @Input() licenseBulkDiscounts: ILicenseBulkDiscount[] = []
  @Input() btnInLicenseName: LicenseBtnNameType
  @Input() toBeatListBtnRoute: string
}
